import { Component, ElementRef, inject, signal, viewChild } from '@angular/core';
import { KeyboardActivityBaseComponent } from '../keyboard-activity-base.component';
import { AudioService } from '@gametailors/leerplus';
import { delay, unsafe } from '@gametailors/web-core/misc';
import { BasicKeyboardActivity } from '../basic-keyboard-activity';

@Component({
  selector: 'lib-keyboard-audio-stimulus-activity',
  imports: [KeyboardActivityBaseComponent],
  templateUrl: './keyboard-audio-stimulus.component.html',
})
export class KeyboardAudioStimulusComponent extends BasicKeyboardActivity {
  protected readonly audioService = inject(AudioService);
  protected readonly audioButtonAnimation = viewChild<ElementRef<HTMLDivElement>>('audioButtonAnimation');
  protected readonly isPlaying = signal(false);

  public override async completeWord() {
    super.completeWord();
    await delay(500);
    await this.playAudio();
  }

  protected async playAudio() {
    const anim = this.audioButtonAnimation();
    if (this.isPlaying() || !anim) return;

    anim.nativeElement.animate(
      [
        {
          transform: 'scale(1)',
          opacity: 1,
        },
        {
          transform: 'scale(2.5)',
          opacity: 0,
        },
      ],
      {
        duration: 400,
        easing: 'ease-in',
      },
    );

    const target = this.targetWord();

    if (target) {
      this.isPlaying.set(true);
      await unsafe(() => this.audioService.play(`words/${target.word}.mp3`).waitForEnd);
      this.isPlaying.set(false);
    }
  }
}
